// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3e9Rt","topBottomGutter":"Layout_topBottomGutter__2pHWa"};